import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/home";
import OrderPage from "./pages/orderpage";
import GTM from "./GTM";
import { CartProvider } from "./pages/CartContext";
import ProductDetails from "./pages/ProductDetails";

function App() {
  return (
    <div className="App">
      <GTM />
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/orderpage" element={<OrderPage />} />
            <Route path="/product-details" element={<ProductDetails />} />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </div>
  );
}

export default App;
